<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { logicHotCollectiveRank } from '@/logic/rank/hotCollective'

const {
  state,
  data,
  getRankData,
} = logicHotCollectiveRank()

await getRankData()
</script>

<template>
  <n-card
    title="集体投诉征集" embedded size="small" class="rounded-md"
    header-style="--n-title-font-weight: bold; --n-padding-bottom: 0.25rem"
  >
    <UtilLoadState :state="state" :reload-handler="getRankData">
      <template v-if="data && data.length">
        <NuxtLink
          v-for="(v, i) in data" :key="i"
          class="mb-1 text-4.25 last:mb-0 line-clamp-1 hover:text-orange-6"
          :to="APP_ROUTER.collectiveDetail(v.collectiveId)"
        >
          {{ v.collectiveTitle }}
        </NuxtLink>
      </template>
      <BasicEmpty v-else />
    </UtilLoadState>
  </n-card>
</template>

<style lang='scss' scoped>
</style>
